import { FC } from "react";

import "./Amount.scss";
import { formatPriceV2 } from "helpers/commonHelpers";

type BodySizes = "sm" | "md" | "lg" | "xl";
type DisplaySizes = "sm" | "md";

export type AmountProps = {
  /**
   * The currency code to display.
   */
  currency: string;
  /**
   * The amount to display.
   */
  amount: number | string;
} & (
  | {
      /**
       * Whether the amount should be displayed in a body context or a display context.
       */
      context?: "body";
      /**
       * The size of the amount component.
       */
      size: BodySizes;
    }
  | {
      /**
       * Whether the amount should be displayed in a body context or a display context.
       */
      context?: "display";
      /**
       * The size of the amount component.
       */
      size: DisplaySizes;
    }
);

const Amount: FC<AmountProps> = function (props) {
  const { amount, currency, size, context = "body" } = props;
  const amountClass = `amount amount--${context} amount--${context}-${size}`;
  const formattedAmount = formatPriceV2(amount);
  return (
    <div className={amountClass}>
      <p className="mb-0 amount-currency">{currency}</p>
      <p className="mb-0 amount-value">{formattedAmount}</p>
    </div>
  );
};

export default Amount;
